import { render, staticRenderFns } from "./RenewCertificate.vue?vue&type=template&id=37445179"
import script from "./RenewCertificate.vue?vue&type=script&lang=js"
export * from "./RenewCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports